import axios from 'axios';

export default {
  customerEmail(customer){
    let email = null;
    if(customer.company!=null && (customer.company.email!=null || customer.company.email != '')){
      email = customer.company.email;
    }else if(customer.contact!=null && (customer.contact.email!=null || customer.contact.email != '')){
      email = customer.contact.email;
    }
    return email;
  },
  customerName(name, usual_name, force=false){
    if(force)return name;
    return usual_name!=null && usual_name!='' ? usual_name : name;
  }
}
